import React from "react";
import {centerThingsWidthHeight} from "../styling/cssclasses";

export default function UnderConstruction() {
  return (
    <div className={centerThingsWidthHeight}><h4>This page is still under construction</h4></div>
  )
}
